import { render, staticRenderFns } from "./PolicyCustomerShort.vue?vue&type=template&id=640e902e&scoped=true"
import script from "./PolicyCustomerShort.vue?vue&type=script&lang=ts"
export * from "./PolicyCustomerShort.vue?vue&type=script&lang=ts"
import style0 from "./PolicyCustomerShort.vue?vue&type=style&index=0&id=640e902e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e902e",
  null
  
)

export default component.exports